import { render, staticRenderFns } from "./TermSetting.vue?vue&type=template&id=7c314f79&scoped=true"
import script from "./TermSetting.vue?vue&type=script&lang=js"
export * from "./TermSetting.vue?vue&type=script&lang=js"
import style0 from "./TermSetting.vue?vue&type=style&index=0&id=7c314f79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c314f79",
  null
  
)

export default component.exports